import {AiFillFacebook, AiOutlineTwitter, AiFillLinkedin} from 'react-icons/ai';

import Footer from '@jobseeker/feature-navigation/widgets/Footer';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';
import {shallowEqual, useSelector} from 'react-redux';
import type {AppState} from '@jobseeker/common-core/types';
import {getPublicAssetUrl} from '@jobseeker/common-core/utils';

const FooterHarness = () => {
  const interceptor: any = useInterceptor();

  const page = useSelector((state: AppState) => state.app.page, shallowEqual);

  const jobLoading = useSelector(
    (state: AppState) => state.job.loadMoreEnabled
  );

  const socialLinks = [
    {
      icon: <AiFillFacebook />,
      url: 'https://www.facebook.com/iimjobs',
      label: 'Facebook',
    },
    {
      icon: <AiFillLinkedin />,
      url: 'https://www.linkedin.com/company/iimjobs.com',
      label: 'LinkedIn',
      // isButton: true,
    },
    {
      icon: <AiOutlineTwitter />,
      url: 'https://twitter.com/iimjobs',
      label: 'Twitter',
    },
  ];
  const {
    footer: {
      logoUrl,
      columnLinks,
      otherLinks,
      bottomLinks,
      headerLabel,
      bgcolor,
    },
    header: {
      meta: {tabsList},
    },
  } = interceptor;

  return (
    <Footer
      logoUrl={getPublicAssetUrl(logoUrl)}
      page={page}
      tabsList={tabsList}
      socialLinks={socialLinks}
      columnLinks={columnLinks}
      otherLinks={otherLinks}
      bottomLinks={bottomLinks}
      headerLabel={headerLabel}
      bgcolor={bgcolor}
      jobLoading={!!jobLoading}
    />
  );
};

export default FooterHarness;
